import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import "pages/login/Login.css";
import axios from "axios";
import { LOGIN_API ,NICE_CERT_ORIGIN} from "constants/apiUrls";
import {getShopIdApi} from "api/loginApi";

const FindLoginId = () => {
  const [error, setError] = useState(false);
  const [bizCheck, setBizCheck] = useState(false); // 사업자등록번호 체크 여부
  const [loginIdList, setLoginIdList] = useState([]);
  const [listCheck, setListCheck] = useState(true);
  const navigate = useNavigate();

  // 사업자등록번호 체크
  const bizCheckEvent = async () => {
    const businessNumber = document.getElementById("businessNumber");
    const value = businessNumber.value

    if (value.length === 10) {
      const getData = await getShopIdApi(value);

      if (getData.isExist) {
        setBizCheck(true);
        setError(false);
      } else {
        setBizCheck(false);
        setError(true);
        businessNumber.value = "";
      }
    } else {
      setBizCheck(false);
      setError(true);
      businessNumber.value = "";
    }
  }

  // 나이스 인증 요청
  const checkEvent = async () => {
    try {
      const getToken = await axios.get(`${LOGIN_API}/cert/nice24`, {
        params: {
          channelType: 2,
          requiredPasswordToken: false,
          certType: 2,
        },
      });

      const newWindow = window.open("", "_blank", "width=400,height=400");
      newWindow.document.open();
      newWindow.document.write(getToken.data);
      newWindow.document.close();

    } catch (error) {
      console.error("Error fetching token:", error);
    }
  };

  // 인증 완료
  const handleMessage = (event) => {
    if (event.origin !== NICE_CERT_ORIGIN) return;
    console.log(event.data.loginIdList)

    if (event.data.loginIdList.length === 0) {
      setListCheck(false);
    } else {
      setListCheck(true);
    }

    setLoginIdList(event.data.loginIdList);
  };

  window.addEventListener("message", handleMessage);

  return (
    <main className="wt-full ht-full d-flex a-center j-center">
      <div className="findBox br-10">
        <div className="tapBox d-flex a-center j-between">
          <Link className="d-block ta-center fs-20 active" to="/v2/findId">아이디 찾기</Link>
          <Link className="d-block ta-center fs-20" to="/v2/resetPassword">비밀번호 변경</Link>
        </div>
        <div className="findBody">
          {loginIdList.length === 0 ?
            <>
              <div className="bizBox">
                <p className="fs-18 fw-7 mb-10">사업자등록번호 조회</p>
                <div className="biz d-flex a-center j-left">
                  <input
                    type='number'
                    className={`text number businessNumber fw-5 ${error ? "redBorder" : ""}`}
                    name="businessNumber"
                    id="businessNumber"
                    maxLength="10"
                    placeholder="사업자등록번호 숫자 10자리 입력"
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <button
                    className="fw-5"
                    onClick={bizCheckEvent}
                  >
                    조회
                  </button>
                </div>
                <p className={`fs-12 fc-red mt-5 ${error ? "" : "d-none"}`}>일치하는 사업자등록번호가 없습니다.</p>
              </div>

              <button
                className={`fc-white fs-20 fw-7 br-10 ${bizCheck ? "bg-blue" : "bg-gray2"}`}
                onClick={checkEvent}
                disabled={!bizCheck}
              >
                NICE 인증으로 아이디 찾기
              </button>
            </> :
            <>
              {listCheck ?
                <>
                  <p className="fs-18 fw-7 mb-5">아이디 찾기가 완료되었습니다</p>

                  <div className="idBoxList scrollbar">
                    {loginIdList.map((value, index) => {
                      return (
                        <div className="idBox br-6 d-flex a-center j-left" key={index}>
                          <div>
                            <p>아이디</p>
                            <p className="fw-7 fs-20 fc-blue2">{value}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <button className="bg-blue fc-white fs-20 fw-7 br-10" onClick={() => navigate("/")}>
                    로그인 하기
                  </button>
                </>:
                <>
                  <p className="fs-18 fw-7 mb-5">입력하신 정보로 아이디를 찾을 수 없습니다.</p>

                  <div className="idBoxList scrollbar">
                    <div className="idBox br-6 d-flex a-center j-left">
                      <div>
                        <p className="fw-5 fc-blue2">입력하신 정보로 등록된 아이디가 없습니다.</p>
                        <p className="fw-7 fs-20 fc-blue2">도움이 필요하시면 고객센터(1800-9991)로 연락해 주세요.</p>
                      </div>
                    </div>
                  </div>
                  <button className="bg-blue fc-white fs-20 fw-7 br-10" onClick={() => navigate("/")}>
                    로그인 화면으로 돌아가기
                  </button>
                </>
              }

            </>
          }

          {/*{!checked ?
            <button className="bg-blue fc-white fs-20 fw-7 br-10" onClick={checkEvent}>NICE 인증으로 아이디 찾기</button> :
            <>
              <p className="fs-18 fw-7 mb-15">
                {idChecked ? "아이디 찾기가 완료되었습니다" : "입력하신 정보로 아이디를 찾을 수 없습니다."}
              </p>
              <div className="idBox br-6 d-flex a-center j-left">
                {idChecked ?
                  <div>
                    <p>아이디</p>
                    <p className="fw-7 fs-20 fc-blue2">{loginId}</p>
                  </div> :
                  <div>
                    <p className="fw-5 fc-blue2">입력하신 정보로 등록된 아이디가 없습니다.</p>
                    <p className="fw-5 fc-gray3">도움이 필요하시면 고객센터(1800-9991)로 연락해 주세요.</p>
                  </div>
                }
              </div>
              <button className="bg-blue fc-white fs-20 fw-7 br-10" onClick={() => navigate("/")}>
                {idChecked ? "로그인 하기" : "로그인 화면으로 돌아가기"}
              </button>
            </>
          }*/}
        </div>
      </div>
    </main>
  );
};

export default FindLoginId;